import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Alert, Loader, Carousel, SliderCarousel } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { isLightProductModel } from '../../helpers.js';
import ProductBlock from '../../ProductBlock/containers/Algolia.js';
import ProductBlock$1 from '../../ProductBlock/containers/CommerceTools.js';

const ProductBanner = ({ products , className , isLoading =true , error , 'data-t': dataT , reimbursableLogos , onProductInteraction , onProductImpression ,  })=>{
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const isPhone = MediaQuery.useIsPhone();
    const itemsPerSlide = MediaQuery.useIsDesktop() ? 4 : 3;
    const classNames = classnames('product-banner', className);
    const { getLabel  } = useIntl();
    const renderProductBlock = React.useCallback((product, index)=>{
        return isLightProductModel(product) ? /*#__PURE__*/ React.createElement(ProductBlock, {
            onClick: ()=>{
                return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, index);
            },
            onImpression: ()=>{
                return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, index);
            },
            key: product.id,
            product: product,
            reimbursableLogos: reimbursableLogos
        }) : /*#__PURE__*/ React.createElement(ProductBlock$1, {
            onClick: ()=>{
                return onProductInteraction === null || onProductInteraction === void 0 ? void 0 : onProductInteraction(product, index);
            },
            onImpression: ()=>{
                return onProductImpression === null || onProductImpression === void 0 ? void 0 : onProductImpression(product, index);
            },
            key: product.id,
            product: product,
            reimbursableLogos: reimbursableLogos
        });
    }, [
        onProductImpression,
        onProductInteraction,
        reimbursableLogos
    ]);
    const carouselItems = React.useMemo(()=>{
        if (!isBigScreen || !products) {
            return [];
        }
        const items = [];
        const max = Math.ceil(products.length / itemsPerSlide);
        for(let i = 0; i < max; i++){
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            items.push(/*#__PURE__*/ React.createElement("div", {
                key: `product-banner-slide-${i}`,
                className: "product-banner__carousel-item"
            }, products.slice(start, end).map((product, index)=>renderProductBlock(product, index)
            )));
        }
        return items;
    }, [
        isBigScreen,
        products,
        itemsPerSlide,
        renderProductBlock
    ]);
    if (error) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames,
            "data-t": dataT || 'product-banner'
        }, /*#__PURE__*/ React.createElement(Alert, {
            type: "warning",
            message: getLabel('products.banner.errorMessage')
        }));
    }
    if (isLoading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classNames,
            "data-t": dataT || 'product-banner'
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    // Render a regular carousel on large screens and a slider carousel on smaller screens
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames,
        "data-t": dataT || 'product-banner'
    }, isBigScreen ? /*#__PURE__*/ React.createElement(Carousel, {
        pagination: false,
        navigation: true
    }, carouselItems) : /*#__PURE__*/ React.createElement(SliderCarousel, {
        itemWidth: isPhone ? 186 : 246
    }, products.map(renderProductBlock)));
};

export { ProductBanner };
//# sourceMappingURL=ProductBanner.js.map
